import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Teleport as _Teleport } from "vue";
const _hoisted_1 = {
  class: "spc-payment-box"
};
const _hoisted_2 = ["onClick"];
const _hoisted_3 = {
  class: "left"
};
const _hoisted_4 = ["src"];
const _hoisted_5 = {
  class: "text"
};
const _hoisted_6 = ["onClick"];
const _hoisted_7 = {
  class: "right"
};
const _hoisted_8 = ["src"];
import { ref, computed, nextTick } from 'vue';
import { useStore } from 'vuex';
import { useLess } from '@/models/hooks';
import constants from '@/constants';
import { useI18n } from 'vue-i18n';
import SelectKycPop from './SelectKYCPop.vue';
import { syncKYCToPaymentInstrument } from '@/models/api/orderConfirmApi';
import { showToastText } from '@/utils/common';
import { awsRumHandler } from '@/utils/awsRumHandler.js';
import { clickEvents } from '@/configs/awsRumConfig';
export default {
  __name: 'SPCPaymentBox',
  emits: ['handleCompleteKyc', 'update:isLoading'],
  setup(__props, {
    expose: __expose,
    emit
  }) {
    var _store$state$checkout;
    useLess('views/spc/orderConfirm/components/SPCPaymentBox.less');
    const {
      t
    } = useI18n();
    const store = useStore();
    const isShowKycPop = ref(false);
    const selectedKYC = ref((_store$state$checkout = store.state.checkout.fillKYC) !== null && _store$state$checkout !== void 0 ? _store$state$checkout : null);
    const checked = ref(1); // Default: WeChat Pay
    const isRefreshSelectKycPopup = ref(true);
    const cmtKYC = computed(() => {
      var _store$state$checkout2;
      if (!((_store$state$checkout2 = store.state.checkout.fillKYC) !== null && _store$state$checkout2 !== void 0 && _store$state$checkout2.holderName)) return '';
      const name = store.state.checkout.fillKYC.holderName;
      const lastNameStr = name.slice(-1);
      return `**${lastNameStr}`;
    });
    const handleClick = item => {
      awsRumHandler.recordClickEvent(clickEvents.checkoutPage.choosePaymentMethodButton);
      checked.value = item.id;
    };
    const handleClickName = () => {
      selectedKYC.value = store.state.checkout.fillKYC;
      isShowKycPop.value = true;
    };
    const handleSelectKYC = async (item, isClose) => {
      if (isClose) {
        isShowKycPop.value = false;
      }
      if (item === null) {
        emit('handleCompleteKyc');
        store.commit('checkout/setFillKYC', item);
        return;
      }
      store.commit('checkout/setFillKYC', {
        maskedId: item.maskedId,
        kycId: item.kycId,
        holderName: item.holderName,
        maskedPhoneNumber: item === null || item === void 0 ? void 0 : item.maskedPhoneNumber,
        frontCitizenUploadToken: item === null || item === void 0 ? void 0 : item.frontCitizenUploadToken,
        backCitizenUploadToken: item === null || item === void 0 ? void 0 : item.backCitizenUploadToken
      });
      try {
        emit('update:isLoading', true);
        const {
          data
        } = await syncKYCToPaymentInstrument({
          kycId: item.kycId,
          paymentInstrumentId: 'default'
        });
        if (data.kycUpdateResultCode === constants.SUCCESS_STATUS_CODE) {
          if (!isClose) {
            showToastText(t('modules.checkout.SAVE_KYC_SUCCESS'), true);
          }
          emit('handleCompleteKyc');
        } else {
          showToastText(t('modules.checkout.FAILED_BIND_ID_CARD_TRY_AGAIN'));
        }
      } catch (error) {
        console.error(error, 'error---api---syncKYCToPaymentInstrument');
        showToastText(t('modules.checkout.FAILED_BIND_ID_CARD_TRY_AGAIN'));
      } finally {
        emit('update:isLoading', false);
      }
    };
    const getKycInfo = () => {
      isRefreshSelectKycPopup.value = false;
      nextTick(() => {
        isRefreshSelectKycPopup.value = true;
      });
    };
    __expose({
      getKycInfo
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(constants).PAYMENT_LIST, item => {
        return _openBlock(), _createElementBlock("div", {
          class: "pay-item",
          key: item.id,
          onClick: $event => handleClick(item)
        }, [_createElementVNode("div", _hoisted_3, [_createElementVNode("img", {
          src: item.icon,
          alt: ""
        }, null, 8, _hoisted_4), _createElementVNode("span", _hoisted_5, _toDisplayString(item.text), 1), cmtKYC.value ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          class: "name",
          onClick: _withModifiers(handleClickName, ["stop"])
        }, _toDisplayString(_unref(t)('modules.checkout.KYC')) + " " + _toDisplayString(cmtKYC.value), 9, _hoisted_6)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_7, [checked.value == item.id ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          class: "checked",
          src: `${_unref(constants).IMAGE_URL}assets/svg/checked.svg`,
          alt: ""
        }, null, 8, _hoisted_8)) : _createCommentVNode("", true)])], 8, _hoisted_2);
      }), 128)), (_openBlock(), _createBlock(_Teleport, {
        to: "#app"
      }, [isRefreshSelectKycPopup.value ? (_openBlock(), _createBlock(SelectKycPop, {
        key: 0,
        show: isShowKycPop.value,
        "onUpdate:show": _cache[0] || (_cache[0] = $event => isShowKycPop.value = $event),
        selectedKYC: selectedKYC.value,
        "onUpdate:selectedKYC": _cache[1] || (_cache[1] = $event => selectedKYC.value = $event),
        onHandleSelectKYC: handleSelectKYC
      }, null, 8, ["show", "selectedKYC"])) : _createCommentVNode("", true)]))]);
    };
  }
};